import { memo, useCallback, useContext, useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, LinearProgress, Radio, RadioGroup, TextField } from "@mui/material";
import { CubeContext } from "@cubejs-client/react";
import { debouncingFn, getReportFilterData } from "../../utils/Reusables";

const FilterTabPanel = ({query,filterObj,filterIndex,filterList,updateFilter}) => {
    const cubejsApi = useContext(CubeContext).cubejsApi
    const [list,setList] = useState([])
    const [loader,setLoader] = useState(false)
    const [search,setSearch] = useState('')
    const [prevSearchKey,setPrevSearchKey] = useState('')

    const handleSearch = useCallback((event) => {
        setPrevSearchKey(search)
        setSearch(event.target.value)
    })

    const asyncFetchFn = useCallback((event,loaderFn,dataFn) => {
        //console.log('Search',event,'Filter',filterObj,query,filterList)
        getReportFilterData(event,{filterObj,cubejsApi,loaderFn,dataFn,queryObj:query,onReport:true,filterList})
    })

    const handleFilterValueChange = useCallback((event) => {
        switch(filterObj.fieldType){
            case 'multiselect':
                filterObj.values = event.target.value
                break;
            case 'Dropdown':
            case 'input':
                filterObj.values = [event.target.value]
                break;
            default:
                console.log(`Filter`,filterObj,event.target.value)
                break;
        }
        filterList.splice(filterIndex,1,filterObj)
        updateFilter([...filterList])
    })

    useEffect(debouncingFn(((list.length == 0 || search != prevSearchKey)) ? () => asyncFetchFn(search,setLoader,setList): () => {}),[search])

    return <Box>        
        <TextField
            variant="outlined"
            label={'Search'}
            name={'filter-title'}
            value={search}
            onChange={handleSearch}
        />
        {loader ? <LinearProgress /> :''}
        <Box>
            {
                filterObj.fieldType == 'Dropdown' && 
                <FormControl>
                    <RadioGroup
                        value={filterObj.values[0] ?? null}
                        onChange={handleFilterValueChange}
                        name="radio-buttons-group"
                    >
                        {
                            list.map((obj,index) => (
                                <FormControlLabel key={`${index}-radio-filter-${obj.value}`} value={obj.value} control={<Radio />} label={obj.label} />
                            ))
                        }                        
                    </RadioGroup>
                </FormControl>
            }
        </Box>
    </Box>
}

export default memo(FilterTabPanel)